import { DataMonitoringExplanation, PopularExplanation, SimiliarUsersExplanation } from '../models/IViewRecommendationInfo';
import { IViewRecommendation } from '../ServerApi/types/IViewRecommendation';

export module RecommendationsHelper {
    export function rankRecommendations(recommendations: IViewRecommendation[]): IViewRecommendation[]{
        const dataChangeRecs: IViewRecommendation[] = [];
        const forYouRecs: IViewRecommendation[] = [];
        const trendingRecs: IViewRecommendation[] = [];
        for (let rec of recommendations) {
          if (rec.explanation.type === DataMonitoringExplanation) {
            dataChangeRecs.push(rec);
          } else if (rec.explanation.type === SimiliarUsersExplanation) {
            forYouRecs.push(rec);
          } else if (rec.explanation.type === PopularExplanation) {
            trendingRecs.push(rec);
          }
        }

        const rankedRecs = [];
        let totalDataChangeRecsAdded = 0, totalForYouRecsAdded = 0, totalTrendedRecsAdded = 0;
        const totalRecs = dataChangeRecs.length + forYouRecs.length + trendingRecs.length;
        while(totalDataChangeRecsAdded + totalForYouRecsAdded + totalTrendedRecsAdded < totalRecs) {
          if (totalDataChangeRecsAdded < dataChangeRecs.length) {
            rankedRecs.push(dataChangeRecs[totalDataChangeRecsAdded]);
            totalDataChangeRecsAdded++;
          }
          if (totalForYouRecsAdded < forYouRecs.length) {
            rankedRecs.push(forYouRecs[totalForYouRecsAdded]);
            totalForYouRecsAdded++;
          }
          if (totalTrendedRecsAdded < trendingRecs.length) {
            rankedRecs.push(trendingRecs[totalTrendedRecsAdded]);
            totalTrendedRecsAdded++;
          }
        }
        return rankedRecs;
      }
}
